import React, { useState, useContext, useEffect } from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import { useShop } from './shopinfo';
import { AuthContext } from './authcontext';
import { useAuth } from "./authcontext";


export const Login = ({ onLogin }) => {
  
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loggedIn, setLoggedIn] = useState();
  const [shopData, setShopData] = useState();
  const navigate = useNavigate();
 
  const { handleLoginInReact } = useContext(AuthContext);


  const getPgidFromSubdomain = () => {
    const subdomain = window.location.hostname.split(".")[0];
    return subdomain.match(/^\d+$/) ? subdomain : null;
  };
  
  const pgid = getPgidFromSubdomain();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/suche';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null); // optional
  
    try {
      const data = await handleLoginInReact(username, password, pgid);
    
      if (from && from !== "/suche") {
        // user came from a specific page → go back there
        navigate(from, { replace: true });
      } else {
        // no specific "from" → go based on user type
        if (data.typ?.toUpperCase() === "A") {
          navigate("/admin", { replace: true });
        } else {
          navigate("/suche", { replace: true });
        }
      }
    } catch (err) {
      setError(err.message || "Login nicht erfolgreich");
    }
  };




        return (
            <div className ="contentContainer">
                <br/>
                <h4>Anmeldung</h4>
                <br/>
                    <div className ="loginFormContainer">
                      <form onSubmit={handleSubmit}>
                        <div>
                            
                            <input 
                              className="suchEingabe"
                              type="text" 
                              id="username" 
                              placeholder="Kundennummer"
                              value={username} 
                              onChange={(e) => setUsername(e.target.value)}/>
                        </div>
                        <br/>

                 
                        <div>
                        
                            <input 
                                type="password" 
                                className="suchEingabe inputStyle"
                                id="loginPasswort" 
                                placeholder="Passwort"
                                value={password} 
                                onChange={(e) => setPassword(e.target.value)}/>
                        </div>
                        {error && <p style={{ color: 'red' }}>{error}</p>}
                        <br />

                          <button  className="umbButton" type="submit">jetzt einloggen</button>
              
                      </form>
                    </div>  
            </div>    
          );
    
};
 
export default Login;




